import { createContext, useContext } from "react";
import { AppLoadResource } from "@ploy-lib/rest-resources";
export const appLoadContext = createContext({
    ...AppLoadResource.fromJS({}),
    refetchApp: () => { },
    refetchCalcRules: undefined
});
appLoadContext.displayName = "AppLoad";
export function useAppLoad() {
    return useContext(appLoadContext);
}
export const AppLoadProvider = appLoadContext.Provider;
export const AppLoadConsumer = appLoadContext.Consumer;
//# sourceMappingURL=appLoadContext.js.map